// 个人中心首页
import request from '@/utils/request'

// 个人中心首页
export function index(data) {
  return request({
    url: '/index/person/index',
    method: 'post',
    data: data,
  })
}

// 个人中心首页获取外来用户信息
export function verify_token(data) {
  return request({
    url: '/index/person/verify_token',
    method: 'post',
    data: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/userCenter/home.js